<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="$l('drawer_title_pdCostsOrderGoodsSpec')"
      :visible="visible"
      direction="rtl"
      :size="1200"
      @close="close"
    >
      <div class="drawer-main">
        <Main
          ref="main"
          :disabled="disabled"
          :pdCostsOrderGoodsCode="pdCostsOrderGoodsCode"
          :pdCostsOrderGoodsSpecCode="pdCostsOrderGoodsSpecCode"
        />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    pdCostsOrderGoodsCode: { type: String, default: '' },
    pdCostsOrderGoodsSpecCode: { type: String, default: '' },
  },
  methods: {
    close() {
      if (!this.disabled) this.$emit('reload')
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 30px 32px;
}
</style>
